import type { JSX } from 'react'

export const BackwardSolidIcon = (): JSX.Element => (
  <use href='#backwardSolidIcon' height='100%' width='100%' />
)
